import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  TableBody,
  Table,
  TableContainer,
  Chip,
  TablePagination,
} from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import NumberFormat from "react-number-format";
import styles from "../../../../styles/global-styles.js";
import StyledTableCell from "../../../../styles/tableCell.jsx";
import StyleTableRow from "../../../../styles/styleTableRow";
import StatelessTableHeadProduct from "../../../stateless/headTables/StatelessTableHeadProduct.jsx";
import { connect } from "react-redux";
import { actions } from "../../../../redux/actions/alert.js";
import { changeRowsPerPage } from "../../../../_utils/utils.js";
import MovileInfoModal from "../../modals/MovileInfoModal.jsx";
import {
  addAvailabilityToProducts,
  getMovilesByFilters,
  movilesAvailableByBarCode,
} from "../utils.inventory.js";
import MovileHeader from "./headers/MovileHeader.jsx";
import BackDrop from "../../../shared/backdrop/Backdrop.jsx";
import { MovileService } from "../../../../services/movile.service.js";

const useStyles = makeStyles((theme) => ({
  title: styles.title,
  rightButton: styles.buttonRightHeader,
  label: styles.label,
  table: {
    minWidth: 700,
  },
  header: styles.header,
  row: styles.rowHover,
  chip: styles.chip,
  subtitle: styles.subtitle,
  lowExistence: styles.lowExistence,
  mediumExistence: styles.mediumExistence,
  highExistence: styles.highExistence,
}));

const MovileInventory = ({
  history: {
    push,
    location: { search },
  },
  addAlert,
  detailAlert,
}) => {
  const classes = useStyles();
  const theme = useTheme();

  const [productArray, setProductArray] = useState({});
  const [availablesInStore, setAvailablesInStore] = useState({});
  const [availablesInSite, setAvailablesInSite] = useState({});
  const [productsAvailable, setProductsAvailable] = useState(false);
  const [quantity, setQuantity] = useState(false);
  const [movileByBarCode, setMovileByBarCode] = useState({});
  const [queryParams, setParams] = useState({});
  /** Pagination */
  const [page, setPage] = React.useState(0);
  const [rowsPerPage, setRowsPerPage] = React.useState(10);

  useEffect(() => {
    setProductsAvailable(false);
    /**pagination with params selected */
    if (Object.values(queryParams).length) {
      const body = {
        ...queryParams,
        page,
        limit: rowsPerPage,
      };
      (async function fetchData() {
        console.log("queryParams", queryParams);
        try {
          const { moviles, count } = await getMovilesByFilters(body);
          getMovileProductsAvailable(moviles);
          setProductArray({ moviles, count });
        } catch (error) {
          console.log("queryParams with pagination", error);
          addAlert({ showAlert: true });
          detailAlert({
            severity: "error",
            message: error.msgs || "Error al procesar tu solicitud",
          });
        }
      })();
    } else {
      (async function fetchData() {
        try {
          const {
            data: { moviles, count },
          } = await MovileService.getMovilesByBarCodeWithPagination({
            page,
            limit: rowsPerPage,
          });
          getMovileProductsAvailable(moviles);
          console.log("moviles", moviles);
          setProductArray({ moviles, count });
        } catch (err) {
          setProductsAvailable(true);
          console.log(err);
          addAlert({ showAlert: true });
          detailAlert({
            severity: "error",
            message: err.msgs || "Error al procesar tu solicitud",
          });
        }
      })();
    }
  }, [page, rowsPerPage]);

  useEffect(() => {
    if (quantity) {
      console.log("QUANTITY");
      const productsWithAvailability = addAvailabilityToProducts(
        productArray.moviles,
        availablesInStore,
        availablesInSite
      );
      setProductArray({
        ...productArray,
        moviles: productsWithAvailability,
      });
      setProductsAvailable(true);
      setQuantity(false);
    }
  }, [quantity]);

  const getMovileProductsAvailable = async (movilesFiltered) => {
    try {
      const { availableInStore, availableInSite } =
        await movilesAvailableByBarCode(movilesFiltered);
      setAvailablesInStore(availableInStore);
      setAvailablesInSite(availableInSite);
      setQuantity(true);
    } catch (error) {
      console.log("error", error);
      addAlert({ showAlert: true });
      detailAlert({
        severity: "error",
        message: error.msg
          ? error.msg
          : "Error al obtener la disponibilidad de productos",
      });
    }
  };

  const goToUrl = (url, { brand, model, barCode }) => {
    return push(url, { brand, model, productTypeId: 1, barCode });
  };

  const handleCloseModal = () => {
    setMovileByBarCode({});
  };

  const handleMovilesFilteredByParams = (movilesFiltered, isSuccess) => {
    const { moviles, count, params } = movilesFiltered;
    if (isSuccess) {
      console.log("handleMovilesFiltered", movilesFiltered);
      setProductsAvailable(true);
      setParams(params);
      getMovileProductsAvailable(movilesFiltered.moviles);
      setProductArray({ moviles, count });
      setPage(0);
    } else {
      addAlert({ showAlert: true });
      detailAlert({
        severity: "warning",
        message: movilesFiltered,
      });
    }
  };

  const handleMovileByBarCodeFiltered = (result, isSuccess) => {
    if (isSuccess) {
      setMovileByBarCode(result);
    } else {
      addAlert({ showAlert: true });
      detailAlert({
        severity: result.movileNotFoundMsg ? "warning" : "error",
        message: result.movileNotFoundMsg
          ? result.movileNotFoundMsg
          : result.msgs,
      });
    }
  };

  const handleChangePage = (event, newPage) => setPage(newPage);

  const handleRowsPerPage = (event) => {
    const { rowsPerPage, page } = changeRowsPerPage(event);
    setRowsPerPage(rowsPerPage);
    setPage(page);
  };

  return (
    <React.Fragment>
      <MovileHeader
        title="Inventario móviles"
        moviles={productArray.moviles}
        movilesInSite={false}
        movilesFiltered={handleMovilesFilteredByParams}
        movileByBarCodeFiltered={handleMovileByBarCodeFiltered}
        rowsPerPage={rowsPerPage}
        loadingProducts={() => setProductsAvailable(false)}
        movileByBarCode={movileByBarCode}
      />

      <Grid style={{ marginTop: theme.spacing(3) }}>
        <TableContainer>
          {productsAvailable ? (
            <Table className={classes.table} aria-label="customized table">
              <StatelessTableHeadProduct isMovile={true} />
              <TableBody>
                {productArray.moviles?.map((row, i) => (
                  <StyleTableRow
                    key={i}
                    className={classes.row}
                    onClick={() =>
                      goToUrl("/dashboard/inventario/detalle-producto", row)
                    }
                  >
                    <StyledTableCell align="center">
                      {row.brand}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.model}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip label={row.color || "-"} className={classes.chip} />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <NumberFormat
                        value={row.cost || 0}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <NumberFormat
                        value={row.price || 0}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <NumberFormat
                        value={row.discount || 0}
                        displayType={"text"}
                        thousandSeparator={true}
                        prefix={"$"}
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      {row.lote || "N/A"}
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={row.availablesInStore}
                        className={
                          row.availablesInStore <= 3
                            ? classes.lowExistence
                            : row.availablesInStore <= 7
                            ? classes.mediumExistence
                            : classes.highExistence
                        }
                      />
                    </StyledTableCell>
                    <StyledTableCell align="center">
                      <Chip
                        label={row.availablesInSite}
                        className={
                          row.availablesInSite <= 3
                            ? classes.lowExistence
                            : row.availablesInSite <= 7
                            ? classes.mediumExistence
                            : classes.highExistence
                        }
                      />
                    </StyledTableCell>
                  </StyleTableRow>
                ))}
              </TableBody>
            </Table>
          ) : (
            <Typography
              variant="h6"
              component="h4"
              style={{ marginTop: 50 }}
              className={classes.subtitle}
            >
              No hay productos en el inventario
            </Typography>
          )}
        </TableContainer>
        {productArray.count > 0 && (
          <TablePagination
            rowsPerPageOptions={[5, 10, 25]}
            component="div"
            count={productArray.count}
            rowsPerPage={rowsPerPage}
            page={page}
            onChangePage={handleChangePage}
            onChangeRowsPerPage={(event) => handleRowsPerPage(event)}
          />
        )}
      </Grid>

      {Object.values(movileByBarCode).length > 0 && (
        <MovileInfoModal
          open={Object.values(movileByBarCode).length > 0}
          detailProduct={movileByBarCode}
          onClose={handleCloseModal}
        />
      )}

      {!productsAvailable && (
        <BackDrop
          style={{
            zIndex: 1,
            color: "#1C2668",
          }}
          isOpen={!productsAvailable}
        />
      )}
    </React.Fragment>
  );
};

const dispatch = {
  detailAlert: actions.detailAlert,
  addAlert: actions.addAlert,
};

export default connect(null, dispatch)(MovileInventory);
